import { Button, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast } from '@chakra-ui/react';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AiFillDelete } from "react-icons/ai";


const ChangeRole = ({ roles, ownerData }) => {
    const [data, setData] = useState([]);
    const isLoading = useSelector((state) => state.user.isLoading);
    const user = useSelector((state) => state.user.userData);
    const toast = useToast();
    const orgId = useSelector((state) => state.user.orgId);
    const isOwner = user.userInfo.userDetailsDto.role === "OWNER";
    const finalData = isOwner ? ownerData : data;

    const getAllUsers = useCallback(() => {
        const params = {
            userId: user.userId,
            orgId
        };
        axios.get(`http://18.132.190.48:8080/api/v1/getAllUsers`, { params })
            .then((r) => {
                setData(r.data);
            })
            .catch((err) => console.log(err));
    }, [user.userId]);

    const changeRole = useCallback((empId, role) => {
        axios.put(`http://18.132.190.48:8080/api/v1/role/update?userId=${user.userId}`, {
            empId,
            roles: role,
        })
            .then((response) => {
                toast({
                    position: 'top',
                    title: 'Role Updated Successfully.',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                })
                getAllUsers();
            })
            .catch((error) => {
                console.log(error);
            });
    }, [user.userId, getAllUsers, roles, toast]);

    const handleDelete = useCallback((empId) => {
        axios.delete(`http://18.132.190.48:8080/api/v1/remove/user?userId=${user.userId}&empId=${empId}`)
            .then(() => {
                toast({
                    position: 'top',
                    title: 'User deleted Successfully.',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                })
                getAllUsers();
            })
            .catch((error) => {
                console.log(error);
            });
    }, [getAllUsers, toast]);

    useEffect(() => {
        getAllUsers();
    }, [getAllUsers]);

    if (isLoading) {
        return <p style={{ textAlign: "center" }}>...Loading</p>
    }
    return (
        <TableContainer w="90%" m="auto" mt={5} bgColor="white">
            <Table>
                <Thead>
                    <Tr>
                        <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Name</Th>
                        <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Email</Th>
                        <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Id</Th>
                        {
                            user.userInfo.userDetailsDto.role === "OWNER" ? "" :
                                <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Organization</Th>
                        }
                        <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Current Role</Th>
                        <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Change Role</Th>
                        {
                            user.userInfo.userDetailsDto.role === "OWNER" ? "" :
                                <Th bgColor="lavender" color="black" py={4} border="1px solid black" textAlign={"center"}>Delete User</Th>
                        }
                    </Tr>
                </Thead>
                {
                    finalData?.map((e) => (
                        <Tbody key={e.empId}>
                            <Tr>
                                <Td textAlign={"center"} border="1px solid" py={2}>{e.fullname}</Td>
                                <Td textAlign={"center"} border="1px solid" py={2}>{e.email}</Td>
                                <Td textAlign={"center"} border="1px solid" py={2}>{e.empId}</Td>
                                {
                                    user.userInfo.userDetailsDto.role === "OWNER" ? "" :
                                        <Td textAlign={"center"} border="1px solid" py={2}>{e.organization}</Td>
                                }
                                <Td textAlign={"center"} border="1px solid" py={2}>{e.role}</Td>
                                <Td textAlign={"center"} border="1px solid" py={2}><Button bgColor="lightblue" w="155px" onClick={() => changeRole(e.empId, e.role === "ADMIN" ? "USER" : isOwner ? "SUPERADMIN" : "ADMIN")} _hover={{ bgColor: "none" }}>
                                    {e.role === "ADMIN" ? "Make User" : isOwner ? "Make SuperAdmin" : "Make Admin"}</Button></Td>

                                {
                                    user.userInfo.userDetailsDto.role === "OWNER" ? "" :
                                        <Td textAlign={"center"} border="1px solid" py={1}><AiFillDelete pl={49} size="25px" color="red" onClick={() => handleDelete(e.empId)} /></Td>
                                }
                            </Tr>
                        </Tbody>
                    ))
                }
            </Table>
        </TableContainer>
    );
};

export default ChangeRole;
